import { convertCamelCaseToSnakeCase } from "@swa-ui/string";

import { isObject } from "../isObject";

/**
 * convertKeysFromCamelCaseToSnakeCase generates an object whose keys are transformed from camelCase to snake_case.
 * @param objectWithCamelCaseKeys the object with keys in camelCase
 * @returns the object with keys transformed from camelCase to snake_case
 */
export const convertKeysFromCamelCaseToSnakeCase = (object: unknown) => {
  const transformObject = (
    obj: Record<string, unknown> | unknown[]
  ): Record<string, unknown> | unknown[] => {
    let output: Record<string, unknown> | unknown[];

    if (Array.isArray(obj)) {
      output = obj.map((item) => handleObjectAndArrays(item));
    } else {
      output = Object.keys(obj).reduce((acc, key) => {
        const camelKey = convertCamelCaseToSnakeCase(key);

        acc[camelKey] = handleObjectAndArrays(obj[key]);

        return acc;
      }, {} as Record<string, unknown>);
    }

    return output;
  };

  function handleObjectAndArrays(item: unknown): unknown {
    return isObject(item) || Array.isArray(item)
      ? transformObject(item as Record<string, unknown> | unknown[])
      : item;
  }

  return isObject(object) ? transformObject(object) : object;
};
